export const GET_MEMBERS = "GET_MEMBERS";
export const RESET_MEMBERS = "RESET_MEMBERS";
export const SET_MEMBERS_REQUEST_STATUS = "SET_MEMBERS_REQUEST_STATUS";
